import React, { useMemo } from 'react';
import { Button, Image, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { getDamagedLabelFieldExampleImageUrl } from '../constants/damagedLabelLookupAssets';

interface DamagedLabelExampleModalProps {
    open: boolean;
    onClose: () => void;
}

const DamagedLabelExampleModal: React.FC<DamagedLabelExampleModalProps> = ({
    open,
    onClose,
}) => {
    const { t, i18n } = useTranslation();

    const exampleImageUrl = useMemo(
        () =>
            getDamagedLabelFieldExampleImageUrl(
                i18n.resolvedLanguage || i18n.language
            ),
        [i18n.language, i18n.resolvedLanguage]
    );

    return (
        <Modal
            title={t('damagedLabelLookup.exampleModalTitle')}
            open={open}
            onCancel={onClose}
            width={560}
            centered
            destroyOnClose
            styles={{ body: { display: 'flex', justifyContent: 'center', paddingTop: 8 } }}
            footer={[
                <Button key="close" onClick={onClose}>
                    {t('components.button.close')}
                </Button>,
            ]}
        >
            <Image
                key={exampleImageUrl}
                src={exampleImageUrl}
                alt={String(t('damagedLabelLookup.exampleImageAlt'))}
                preview={false}
                style={{ maxWidth: 480, width: '100%', height: 'auto' }}
            />
        </Modal>
    );
};

export default DamagedLabelExampleModal;
